import Chart from 'chart.js/auto';
// Importamos el plugin del treemap
Chart.register(TreemapController, TreemapElement);

import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
const chartColor = require('./chart-color');



export function start(detail) {
    obj[detail.act].start(detail);
}

const obj = {
    createSimple: { start: (detail) => { createSimple(detail); } },
};

function createSimple(detail) {
    const datos = {
        label: 'Item',
        tree: detail.data,
        key: 'value',
        groups: ['name'], // Asegúrate de que esto coincida con la propiedad de tu data

        borderWidth: 1,
        spacing: 0.1,
        backgroundColor: (ctx) => {
            if (ctx.type !== 'data' || !ctx.raw) return 'transparent';
            return chartColor.generateRandomRGB().base;
        },
        hoverBackgroundColor: (ctx) => {
            if (ctx.type !== 'data' || !ctx.raw) return 'transparent';
            return chartColor.generateRandomRGB().hover;
        },
        borderColor: (ctx) => {
            if (ctx.type !== 'data' || !ctx.raw) return '#ffffff';
            return chartColor.generateRandomRGB().border;
        },
        labels: {
            display: true,
            color: 'white',
            font: { size: 14, weight: 'bold' },
            align: 'center',
            position: 'middle',
            formatter:(ctx) => {
                return `${ctx.raw._data.children[0].name} - ${ctx.raw._data.children[0].value}`;
            },
        }
    }

    const setup = {
        type: 'treemap',
        data: {
            datasets: [datos]
        },
        options: {
            scales: {
                x: { display: false },
                y: { display: false }
            },
            
            plugins: {
                datalabels: {
                    display: false
                },
                title: {
                    display: false,
                    text: '' //titulo de la grafica
                },
                legend: {
                    display: false
                },
                
            }
        }
    };

    // Aplicar opciones externas sin romper las escalas
    if (detail.options) {
        optionsCheck(detail, setup);
    }

    detail.targetChart.chart = new Chart(detail.targetChart.html, setup);
}

function optionsCheck(detail, setup) {
    if (!detail.options) return;
    if (detail.options.aspectRatio !== undefined) setup.options.aspectRatio = detail.options.aspectRatio;
    if (detail.options.legend !== undefined) setup.options.plugins.legend.display = detail.options.legend;
}
